export default __webpack_public_path__ + "static/media/hindi_other_f.903295db.wav";